// AI-CONTEXT: See docs/features/platform-revenue-churn-trend.md
import PageHeader from '../../components/layout/PageHeader'
import SectorTrendChart from '../../components/admin/SectorTrendChart'
import usePlatformRevenue from '../../hooks/usePlatformRevenue'
import buildSectorSeriesRows from '../../helpers/dashboard/buildSectorSeriesRows'
import mrrDisplay from '../../helpers/dashboard/mrrDisplay'
import formatEuro from '../../helpers/formatEuro'

const CENTS_PER_EURO = 100

/**
 * De maandelijkse omzet over de tijd, totaal en per sector. Bereikbaar door op
 * het bedrag van de MRR-tegel te klikken (Deccos-beheertenant).
 *
 * De punten zijn de maanddocumenten van de nachtrun (PlatformRevenue/{YYYY-MM});
 * de laatste run van een maand bevriest die maand. De uitsplitsing per sector
 * (MrrCentsBySector) bestaat pas sinds 2026-10; eerdere maanden hebben alleen
 * een totaal.
 *
 * Drie toestanden in deze volgorde: nog niet bekend, mislukt, inhoud.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 */
const PlatformRevenue = () => {
    const { current, history, loading, error } = usePlatformRevenue()

    const { rows, sectors, sectorsSince } = buildSectorSeriesRows(
        history.map((h) => ({
            period: h.Period,
            total: Number.isFinite(h.MrrCents) ? h.MrrCents : null,
            bySector: h.MrrCentsBySector || null,
        })),
        { scale: (cents) => cents / CENTS_PER_EURO },
    )

    const nu = mrrDisplay(current)

    return (
        <div className='platform-trend'>
            <PageHeader heading='Maandelijkse omzet' />

            {loading && <p className='platform-trend__state'>Bezig met laden…</p>}

            {!loading && error && (
                <p className='platform-trend__state platform-trend__state--error'>{error}</p>
            )}

            {!loading && !error && (
                <div className='dashboard-container platform-trend__card'>
                    {nu.value && (
                        <p className='platform-trend__summary'>
                            {`Nu ${nu.value} per maand`}
                            {nu.note && <span className='platform-trend__summary-note'>{` · ${nu.note}`}</span>}
                        </p>
                    )}
                    <SectorTrendChart
                        rows={rows}
                        sectors={sectors}
                        sectorsSince={sectorsSince}
                        totalKind='line'
                        totalLabel='Omzet per maand'
                        formatValue={formatEuro}
                    />
                </div>
            )}
        </div>
    )
}

export default PlatformRevenue
